import React, { useState } from "react";

// import JS files
import PersonsCard from "../shares/others/PersonsCard";
import Header from "../shares/others/Header";
import useFetch from "../../context/useFetch";

// import others files

const Persons = (props) => {
  const [newsList, setNewsList] = useState([]);
  const getSpecialListApi = useFetch({
    method: "get",
    url: "News_Service/get_face_news",
    noHeader: true,
    trigger: true,
    argFunc: (res) => {
      setNewsList(res);
    },
  });

  return (
    <>
      <div className="mt-8 md:mt-16">
        <Header header="چهره‌ها" redirect_url="/opinion-list" />
        <div className=" grid md:grid-cols-4  gap-4 md:gap-8">
          {newsList.map((it, ind) => {
            return [<PersonsCard data={it} />];
          })}
        </div>
      </div>
    </>
  );
};

export default Persons;
